export default __webpack_public_path__ + "static/media/icon6.49014b93.png";